export default __webpack_public_path__ + "static/media/arrow-view-round.3516c17e.svg";